import React, { useEffect, useState, Suspense, useRef } from "react";
import Select from "components/select/select";
import InputEdit from "./components/input-edit";
import { useTranslation } from "react-i18next";
import { currentLang,removePostalCode,formatDate,urlSerializer,imageSquareOrPortrait,cleanQuillContent } from "utils/utils";
import _ from "lodash";
import InputType from "components/input/input-type";
import { useWindowDimensions } from "utils/customhooks";
import Favicon from "components/fav-icon/Favicon";
import LinkIconSVG from "assets/svg/link-icon";
import VideoFileIconSVG from "assets/svg/video-file-icon";
import VideoEmbedIconSVG from "assets/svg/video-embed-icon";
import AudioIconSVG from "assets/svg/audio-icon";
import ImageIconSVG from "assets/svg/image-icon";
import TextIconSVG from "assets/svg/text-icon";
import update from "immutability-helper";
import { usePrivacies } from "redux/modules/privacy/hooks";
import { useDialogHook } from "utils/customhooks";
import DateEdit from "./components/date-edit";
import { usePositions } from "redux/modules/position/hooks";
import PositionEdit from "./components/position-edit";
import { useCategories } from "redux/modules/category/hooks";
import CreatableSelect from "components/select/creatable";
import Button from "components/button/button";
import toast from "react-hot-toast";
import { isValidHttpUrl, mediaTypes_init, mediaSubTypes_init } from "utils/constant";
import validator from "validator";
import { useMilestones } from "redux/modules/milestone/hooks";
import { CoverPlaceholderMilestone } from "constants/images";
import LazyImage from "../LazyImage";
import { FiCamera } from "react-icons/fi";
import FileUpload from "components/file-upload/file-upload";
import EditThumbnailModal from "../edit-thumbnail";
import { FaPlus } from "react-icons/fa6";
import MediaButtonEdit from "./components/media-btn";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import AutoCompleteAddress from "components/google-address/auto-complete";
import Input from "components/input/input";

const WYSIWYGEditor = React.lazy(() => import('components/wysiwyg/wysiwyg')); 

const DetailedViewEdit = ({
    title,
    date,
    buttons = [],
    positions = [],
    milestone,
    profile,
    cancelEdit,
    url,
    userData,
    group,
    updateMilestonesState,
    location="",
    platform=""
})=>{
    const { http } = global.services;
    const {t} = useTranslation();
    const startDate = useRef(null);
    const endDate = useRef(null);
    const contentRef = useRef();
    const removelinkType = useRef([]);

    const dateEditDialog = useDialogHook(DateEdit);
    const postionDialog = useDialogHook(PositionEdit);
    const edit = useDialogHook(EditThumbnailModal);
    const mediaDialog = useDialogHook(MediaButtonEdit);
    
    const [editMilestone, setEditMilestone] = useState(milestone);
    const [submitLoading, setSubmitLoading] = useState(false);
    
    const { organizeBy, buttonCount } = useMilestones();
    
    const {
        refresh: refreshPrivacies,
        initialize: initializePrivacies,
        privacies,
        setPrivacies,
      } = usePrivacies();
    
    const {
        refresh: refreshPosition,
        initialize: initializePosition,
        positions:positionList,
        setPositions,
      } = usePositions();
    
      const {
        refresh: refreshCategory,
        initialize: initializeCategory,
        categories:categoryList,
        setCategories,
      } = useCategories();

    const [state, setState] = useState({
        title: title,
        date: date,
        desc:milestone.description,
        category:[],
        positions:positions,
        location:location,
        platform:platform
    })
    const [showAllMedia, setShowAllMedia] = useState(false);
    const [errorMessages,setErrorMessages] = useState();
    const { isMobile } = useWindowDimensions();
    const [linkTypeList, setLinkType] = useState(milestone.media_type);
    const [jobsList, setJobs] = useState([]);
    const [descShow, setDescShow] = useState(false);
    const [dateDis, setDate] = useState(date);
    const [imageHeight, setImageHeight] = useState(null);
    const [cropFile, setCropFile] = useState(null);
    const [preview, setPreview] = useState(null);
    
    useEffect(() => {
        (async () => {
          if (!url) {
            setPreview(null);
            setImageHeight(300);
            return;
          }
          const res = await imageSquareOrPortrait(url);
          const element = contentRef.current;
          if (res === "portrait" && element) {
            if (element) {
              if (element.offsetHeight < 300) {
                setImageHeight(300);
              } else {
                setImageHeight(element.offsetHeight);
              }
              setPreview(url);
            }
          } else {
            setPreview(url);
          }
        })();
      }, [url]);

    const handleInputChange = async (e) => {
        const { name, value } = e.target;
        
        const hasValue = (value) => {
            return categoryList.includes(value[value.length - 1]);
        }

        if (name === "category" && !hasValue(value)) {
            const newValue = value[value.length - 1];
            const data = await createCategory(newValue);
            const indx = value.findIndex(v => {
            return v.label === newValue.label;
        });
        if(indx > -1) value[indx].value = data?.id;
        }

        setState((prev) => ({
        ...prev,
        [name]: value,
        validationErrors: { ...state.validationErrors, [name]: null },
        }));
        setErrorMessages((prev)=>(
            {
                ...prev,
                [name]:null
            }
        ))
    };
    const createCategory = async (e) => {
        try {
        let { data } = await http.post("public/categories", {
            user_id: profile.user_id,
            user_profile_id: profile.id,
            category: e.label,
        }); 
        getCategories();
        return data.data;
        } catch (err) {
        console.log(err);
        }
    };
    const iconData = (obj={})=>{
         let inputIcon = null;
        if (obj.subType === "Link") {/**obj?.fav_icon from library */
            inputIcon = obj?.value ? (
            <Favicon domain={obj.value} hasFavIconFile={obj?.fav_icon || null}/>
            ) : (
            <LinkIconSVG className="text-lg" />
            );
        } else if (
            obj.subType === "Video Embed" ||
            obj.subType === "Embed"
        ) {
            inputIcon = obj?.value ? (/**obj?.fav_icon from library */
            <Favicon domain={obj.value} hasFavIconFile={obj?.fav_icon || null}/>
            ) : (
            <VideoEmbedIconSVG className="text-lg" />
            );
        } else if (obj.subType === "Audio File") {
            inputIcon = <AudioIconSVG className="text-lg" />;
        } else if (
            obj.subType === "Multiple Images" ||
            obj.subType === "Single Image"
        ) {
            inputIcon = <ImageIconSVG className="text-lg" />;
        } else if (obj.subType === "Upload") {
            if (obj?.label === "Watch") {
            inputIcon = <VideoFileIconSVG className="text-lg" />;
            } else {
            inputIcon = <TextIconSVG className="text-lg" />;
            }
        }
        return inputIcon
    }

    const onLabel = async (e, index) => {
        let payload = _.clone(linkTypeList);
        let result = update(payload, {
          [index]: {
            label: { $set: e.target.value },
          },
        }); 
        setLinkType(result);
        setState((prev)=>({...prev, media: result}))
    }

    const getPrivacies = async () => {
        try {
          const lang = currentLang();
          const { data } = await http.get("public/privacies");
          const privacies = data.map((category) => ({
            label: lang ? (category[lang] || category.name) : category.name,
            name: category.name,
            value: category.name,
          }));
          setPrivacies(privacies);
        } catch (err) {
          console.log("error@getPrivacies", err);
          throw err;
        }
    };
    const getPositions = async () => {
        try {
          const url = urlSerializer("public/positions", {
            user_profile_id: profile.id,
          });
    
          const lang = currentLang();
          const { data } = await http.get(url);
          const positions = data.map((position) => ({
            label: lang ? (position[lang] || position.name) : position.name,
            value: position.id,
            name: position.name
          }));
          setPositions(positions);
        } catch (err) {
          console.log("error@getPositions", err);
          throw err;
        }
    };

    const getCategories = async () => {
        try {
          const url = urlSerializer("public/categories", {
            user_profile_id: profile.id,
          });
          const lang = currentLang();
          const { data } = await http.get(url);
          const categories = data.map((category) => ({
            // label: !profile.dateFormat ? (category.english_version || category.name) : category.name,
            value: category.id,
            label: lang ? (category[lang] || category.name) : !profile.dateFormat ? (category.english_version || category.name) : category.name
          }));
          setCategories(categories);
        } catch (err) {
          console.log("error@getCategories", err);
          throw err;
        }
      };
    
    useEffect(() => {
    if (initializeCategory) getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshCategory]);

    useEffect(() => {
        if (initializePosition) getPositions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [refreshPosition]);

    useEffect(() => {
        if (initializePrivacies) getPrivacies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [refreshPrivacies]);

    useEffect(()=>{
        const privacy = privacies.filter((c) => c.value === milestone.privacy);
        let categories = milestone.categories.map((item => {return {label: item[currentLang()] || item.name, value:item.id}}));
         setState((prev)=>({...prev, privacy: privacy[0], category:categories}))
    },[milestone,privacies,positions]);

    useEffect(()=>{
        getMilestonePositions();
        let desc = milestone.description;
        if (!_.isEmpty(milestone.mention_names)) {
            Object.keys(milestone.mention_names).forEach((k) => {
                const pUsername = milestone.mention_names[k]?.p_username;
            
                // Regex to match href containing username and capture the name between <a> and </a>
                // const regex = new RegExp(`(<a[^>]*href="[^"]*${username}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
                const regex = new RegExp(`(<a[^>]*key="[^"]*${pUsername}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
                desc = desc.replace(regex, (match, openingTag, name, closingTag) => {
                    return `${openingTag}@${pUsername}${closingTag}`;
                });
            }); 
        }
        setState((prev)=>({...prev,desc:desc}));
        setDescShow(true);

        let star = {
            day: milestone.start_day,
            month: milestone.start_month,
            year: milestone.start_year,
            approximately: milestone.is_start_date_approximately ? true : false,
        };

        let end = {
            day: milestone.end_day,
            month: milestone.end_month,
            year: milestone.end_year,
            present: milestone.is_present ? true : false,
            approximately: milestone.is_end_date_approximately ? true : false,
        };
        startDate.current = star;
        endDate.current = end;

        if (!_.isEmpty(milestone.media_type)) {
              let links = [];
              milestone.media_type.forEach((media) => {
                const { name, option, ...rest } = media.sub_type;
                if (name === "Multiple Images") {
                  links.push({
                    id: media.id,
                    type: media.type.name,
                    subType: name,
                    subTypeId: media.sub_type.id,
                    order: media.order,
                    label: media.label,
                    value: media.media,
        
                  });
                } else {
                  let val = {
                    id: media.id,
                    type: media.type.name,
                    subType: name,
                    subTypeId: media.sub_type.id,
                    order: media.order,
                    label: media.label,
                    value: media.url,
                    orientation:media?.orientation,
                    fav_icon: media?.fav_icon?.url
                  };
        
                  if (media.hasOwnProperty("media") && media.media.length > 0) {
                    val.value = media.media[0];
                    val.placeholder = media.media[0]["media"]["file_name"];
                  } else {
                    val.value = media.url;
                  }
                  val.other_description = media?.other_description;
                  links.push(val);
                }
              });
              setLinkType(links);
            }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[milestone])


    const showDate = ()=>{
        dateEditDialog({milestone:editMilestone, start_date:startDate.current, end_date:endDate.current},(callback)=>{
            if(callback?.success){
                startDate.current = callback.startDate;
                endDate.current = callback.endDate;
                let newMilesone = {...milestone, ...callback.date}
                const featuredDate = formatDate(newMilesone, profile?.dateFormat, t);
                setEditMilestone(newMilesone);
                setDate(featuredDate);
                setState(prev=>({...prev, startDate:callback.startDate, endDate:callback.endDate}))
            }
        })
    }

    const showPosition = ()=>{
        postionDialog({positionList,profile,jobsList,getPositions},(callback)=>{
            if(callback?.success){
                setJobs(callback.jobs);
                setState(prev=>({...prev, jobs:callback.jobs}))
            }
        })
    }

    const getMilestonePositions = async () => {
        let positions = [];
        try {
            const { data } = await http.get(
                `public/milestones/${milestone.id}/positions`
            );
            const lang = currentLang();
            data.forEach((p) => {
                positions.push({
                job_role: {
                    label: p.position[lang] || p.position.name,
                    value: p.position_id,
                    name: p.position.name
                },
                description: p.description || "",
                });
            });
        
            setJobs(positions);
            setState(prev=>({...prev, jobs:positions}))
            } catch (err) {
            console.log("error@getMilestonePositions", err);
            throw err;
            }
    };
 
    const submitHandler = async()=>{
        try{ 
            setSubmitLoading(true)
            let errors = {};
            setErrorMessages(errors);
            let thumbnail = cropFile;
             //validate date
            let concatStartDate = `${startDate.current.year}-${startDate.current.month ?? "00"}-${
                startDate.current.day ?? "00"
            }`;
            let concatEndDate = endDate.current.present
                ? null
                : endDate.current.year
                ? `${endDate.current.year}-${endDate.current.month ?? "00"}-${endDate.current.day ?? "00"}`
                : null;
        
            if (!_.isEmpty(concatStartDate) && !_.isEmpty(concatEndDate)) {
                if (new Date(concatStartDate) > new Date(concatEndDate)) {
                errors = {
                    ...errors,
                    "start_date.day": [""],
                    "start_date.month": [""],
                    "start_date.year": [""],
                    "end_date.day": [""],
                    "end_date.month": [""],
                    "end_date.year": [""],
                    errorDates: ["The start date must be less than the end date."],
                };
                }
            }
            //end validate date
        
            if (startDate.current.day > 31) {
                errors = {
                ...errors,
                "start_date.day": ["The day field should not be greater than 31."],
                };
            }
            if (startDate.current.month > 12) {
                errors = {
                ...errors,
                "start_date.month": ["The month field should not be greater than 12."],
                };
            }
            if (endDate.current.day > 31) {
                errors = {
                ...errors,
                "end_date.day": ["The day field should not be greater than 31."],
                };
            }
            if (endDate.current.month > 12) {
                errors = {
                ...errors,
                "end_date.month": ["The month field should not be greater than 12."],
                };
            }

            let formData = new FormData();
             // attach profile type to filter
            formData.append("thumbnail", thumbnail);
            formData.append("deleteThumbnail", (!thumbnail && !preview) ? 1 : 0);
            formData.append("profile_type", profile.profile_type.type);
            const cleanDescription =state.desc && cleanQuillContent(state.desc.replace(/<span[^>]*style=['"]?\s*color\s*:\s*blue;?['"]?[^>]*>([\s\S]*?)<\/span>/gi,'$1'));
            formData.append("description", cleanDescription);
            formData.append("user_id", profile.user_id);
            formData.append("user_profile_id", profile.id);
            formData.append("title", state.title);
            formData.append("platform", state?.platform || "");
            formData.append("location", state?.location || "");
            // formData.append("date_note", "");
            formData.append("order", milestone?.order || 0);
            
            jobsList.forEach((p, index) => {
                if (typeof p.job_role === "object") {
                    const { value } = p.job_role;
                    formData.append(`position[${index}][job_role]`, value);
                } else {
                    formData.append(`position[${index}][job_role]`, p.job_role);
                }

                formData.append(`position[${index}][description]`, p.description);
            });

            removelinkType.current.forEach((r, index) => {
                if (r.id) {
                    formData.append(`remove[${index}][button_id]`, r.id);
                }
            });

            // media
            linkTypeList.forEach(async (media, index) => {
                let mediaData = _.clone(media);
                if (mediaData.subType === "Link") {
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Website").value;
                    mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Link").value;
                    mediaData.is_media = false;
                }
                else if (mediaData.subType === "Video Embed") {
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Watch").value;
                    mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Video Embed").value;
                    mediaData.is_media = false;
                }
                else if (mediaData.subType === "Audio File") {
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Listen").value;
                    mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Audio File").value;
                    mediaData.is_media = true;
        
                }
                else if (mediaData.subType === "Multiple Images") {
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Images").value;
                    mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Multiple Images").value;
                    mediaData.is_media = true;
                for(let i = 0; i < mediaData.value.length; i++){
                    if(mediaData.value[i].progress){
                    errors = {
                        ...errors,
                        "images": ["Please wait until the image is uploaded.."],
                    };
                    return toast.error(t('somethingWentWrong'));
                    }
                }
                }
                else if (mediaData.subType === "Upload") {
                if(mediaData.type === "Watch"){
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Watch").value
                }
                else{
                    mediaData.type = mediaTypes_init.find((mt) => mt.label === "Read").value;
                }
                mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Upload").value;
                mediaData.is_media = true;
                }
        
                if(typeof mediaData.type === 'string'){
                mediaData.type = 1;
                }
                if(typeof mediaData.subTypeId === 'string'){
                mediaData.subTypeId = 5;
                }
        
        
                if (media.type || media.subType) {
                formData.append(`media[${index}][button_id]`, mediaData.id);
                formData.append(`media[${index}][type]`, mediaData.type);
                formData.append(`media[${index}][sub_type]`, mediaData.subTypeId);
                formData.append(`media[${index}][is_media]`, mediaData.is_media);
                formData.append(`media[${index}][order]`, mediaData.order);
                formData.append(`media[${index}][label]`, mediaData.label);
                formData.append(`media[${index}][orientation]`, mediaData?.orientation || []);
        
                if (typeof media.value === "object") {
                    if (Array.isArray(media.value)) {
                    media.value.map(async (file, fileIndex) => {
                        if (file.hasOwnProperty("media")) {
                        formData.append(
                            `media[${index}][media_id][${fileIndex}]`,
                            file.media_id
                        );
                        formData.append(
                            `media[${index}][value][${fileIndex}]`,
                            JSON.stringify(file)
                        );
                        } else {
                        formData.append(`media[${index}][value][${fileIndex}]`, file);
                        }
                    });
                    } else {
                    if (media.value.hasOwnProperty("media")) {
                        formData.append(
                        `media[${index}][media_id][0]`,
                        media.value.media_id
                        );
                        formData.append(
                        `media[${index}][value][0]`,
                        JSON.stringify(media.value)
                        );
                    } else {
                        formData.append(`media[${index}][value][0]`, media.value);
                    }
                    }
                } else {
                    //validate
                    if (media?.subType?.is_link || !mediaData.is_media) {
        
                    if (media.value) {
                        if(media.value.includes('wikipedia.')){
                        formData.append(`media[${index}][value]`, media.value);
                        }
                        else if (validator.isURL(media.value) && isValidHttpUrl(media.value)) {
                        formData.append(`media[${index}][value]`, media.value);
                        } else {
                        errors = {
                            ...errors,
                            [`media.${media.value}.value`]: "Invalid url link.",
                        };
                        }
                    } else {
                        formData.append(`media[${index}][value]`, media.value);
                    }
                    } else {
                    formData.append(`media[${index}][value]`, media.value);
                    }
                }
                formData.append(`media[${index}][other_description]`, media.other_description);
                }
            });

            if (!_.isEmpty(errors)) {
                return setErrorMessages((prev) => ({ ...prev, ...errors }));
            }

            if(Array.isArray(state.category) && state.category?.length > 0) {
                state.category.forEach((category, index) => {
                    formData.append(`category[${index}]`, category.value);
                });
            }

            if (state.privacy) formData.append("privacy", state.privacy.value);
            
            formData.append("is_featured", Boolean(milestone?.is_featured));
            formData.append("is_adult_content", milestone?.is_adult_content ? false : true);

            if (startDate.current.day) {
                formData.append("start_date[day]", startDate.current.day);
            }

            if (startDate.current.month) {
                formData.append("start_date[month]", startDate.current.month);
            }

            if (startDate.current.year) {
                formData.append("start_date[year]", startDate.current.year);
            } else {
                errors = {
                    ...errors,
                    "start_date.year": ["The year field is required."],
                };
            }
            if (endDate.current.day) formData.append("end_date[day]", endDate.current.day);
            if (endDate.current.month) formData.append("end_date[month]", endDate.current.month);
            if (endDate.current.year) formData.append("end_date[year]", endDate.current.year);

            formData.append("start_date[approximately]", startDate.current.approximately);
            formData.append("end_date[approximately]", endDate.current.approximately);
            formData.append("end_date[present]", endDate.current.present);
            formData.append("organize_by", organizeBy);
            formData.append("_method", "PUT");
            
            const { data } = await http.post(
            `public/milestones/${milestone?.id}`,
                formData,
                {
                headers: {
                    "content-type": "multipart/form-data",
                },
                mode: "no-cors",
                }
            );
            console.log("create milestone return data => ", data);
            const result = { success: true, data: data.data }
            updateMilestonesState(result,group);
            cancelEdit()
        }catch(err){
            console.log("error@submit", err);
            const { data, status } = err;
            if (status === 422) {
                console.error(data.errors)
            }
            toast.error(
                status === 422 ? data?.message : t('somethingWentWrong')
            );
                setSubmitLoading(false);
            } finally {
                setSubmitLoading(false);
            }
    }

    const onUploadImage = async (file) => {
        setCropFile(file);
    };

    const onEditThumbnail = (image, type) => {
        if (image) {
        edit({ image: image, type: type, returnType: "blob" }, (result) => {
            if (result) {
            const { imageFile, preview } = result;
            setCropFile(imageFile);
            setPreview(preview);
            }
        });
        }
    };

    const showMediaModal = ()=>{
        mediaDialog({userData,linkTypeList,buttonCount},(callback)=>{
            if(callback?.success){
                setLinkType(callback.linkType);
                removelinkType.current = callback.removelinkType
            }
        })
    }

    const PicButton = ()=>{
        return(
            <div className="cursor-pointer absolute z-[9998] right-2 sm:right-4 top-2 2sm:top-4 w-9 h-9 bg-black bg-opacity-50 rounded-md flex items-center justify-center">
                <FileUpload
                    onUpload={onUploadImage}
                    optional={true}
                    preview={preview}
                    setPreview={setPreview}
                    onEdit={(image, type) => onEditThumbnail(image, type)}
                    cropOnload={true}
                    accept="image/*"
                    // onDelete={handleDeleteImage}
                    quicEdit={true}
                    icon={ <FiCamera className="text-white text-lg cursor-pointer" />}
                />
            </div>
        )
    }

    const handleAddressChange = (fieldName, addressValue) => {
        setState((prev) => ({
        ...prev,
        [fieldName]: addressValue,
        validationErrors: { ...prev.validationErrors, [fieldName]: null },
        }));
    };

    return (
        <div
            className={`w-full flex flex-col 2md:flex-row space-y-0.5 2md:space-x-0.5 2md:space-y-0 relative  ${
            preview ? "min-h-300" : "min-h-300"
            }`}
        >
            {
                submitLoading && 
                <div className="absolute inset-0 bg-white/30 backdrop-blur-sm flex items-center justify-center z-[9999]">
                    <span className="text-lg font-semibold text-gray-700">Updating ...</span>
                </div>
            }
            
            {preview ? (
            <div className="relative bg-white h-auto 2md:min-h-[300px] 2md:w-[300px]">
                {/* thumbnail */}
                <LazyImage
                viewUrl={preview}
                source={preview}
                customClassName="w-full md:max-w-[300px] h-auto 2md:max-h-[300px]"
                imageHeight={imageHeight}
                withContainer="w-full 2md:w-[300px]"
                />
                <PicButton/>
            </div>
            ) : (
            <div className="relative min-h-[300px] 2md:w-[300px] flex items-center justify-center bg-[#e9e9e9]">
                <div className="w-full 2md:w-[300px] flex items-center justify-center h-full bg-[#e9e9e9]">
                <img
                    src={CoverPlaceholderMilestone}
                    alt="Milestone"
                    className="h-[111px] w-[113px]"
                />
                </div> 
                <PicButton/>
            </div>
            )}
            <div
            className={`relative bg-white 
                        lg:mt-0 lg:py-4 lg:px-7.5 
                        sm:px-7 sm:pb-7 sm:pt-7
                        px-3 pb-6 pt-4 p-7 w-full ${
                        preview
                            ? "width-responsive-detailed-view"
                            : "width-responsive-detailed-view-full"
                        }`} 
            >
            <div className="w-full h-full relative">
                <div className="absolute -top-[35px] 2sm:-top-[32px] right:4 sm:-right-4">
                    <div className="flex gap-2"> 
                        {/* <Button
                        buttonName={t('quickEditMode')}
                        buttonClass="bg-[#e8e8e8] py-2 px-4 hover:bg-gray"
                        buttonTextClass="text-black text-2xs 2sm:text-xs font-semibold flex gap-2 items-center"
                        disabled={submitLoading}
                        icon={<HiOutlinePencilSquare className="text-base"/>}
                        iconPosition="left"
                        /> */}
        
                        <Button
                        buttonName={t('cancel')}
                        buttonClass="bg-[#e8e8e8] py-2 px-4 hover:bg-gray"
                        buttonTextClass="text-red text-2xs 2sm:text-xs font-semibold"
                        onClick={cancelEdit}
                        disabled={submitLoading}

                        />
        
                        <Button
                        buttonName={t('saveChanges')}
                        buttonClass="bg-[#e8e8e8] py-2 px-4 hover:bg-gray"
                        buttonTextClass="text-primary text-2xs 2sm:text-xs font-semibold"
                        onClick={submitHandler}
                        disabled={submitLoading}

                        />
                    </div>
                </div>
                <div className="py-2">
                    <InputEdit
                        inputContainerClass="form-input-container"
                        value={state.title}
                        name="title"
                        outsideLabel={t("title")}
                        placeholder={t("starWars")}
                        outsideLabelClass="text-sm font-bold text-darkerGray marked"
                        noLabelPaddingY="0.8rem"
                        type="text"
                        onChange={(e)=>{handleInputChange(e)}}
                        errorMessagePosition="bottom"
                        errorMessage={errorMessages?.title}
                    />
                </div>
                <div className="flex gap-2 -mb-[22px] flex-wrap">
                    <div className="flex-1 w-full">
                        <div className="relative w-full bg-white rounded-md pl-2 pr-2 pt-1 border border-gray cursor-pointer h-[4.2rem]" onClick={showDate}>
                            <label className="block font-semibold text-gray-400 text-2xs 3md:text-xs pt-2">Date Range</label>
                            <p className="text-[13px] sm:text-sm 3md:text-base 3md:leading-6 pt-1">
                                {dateDis}
                            </p>
                            {
                                errorMessages?.startDate?.year &&
                                <p className="input-error-message mt-2 -mb-1">* {errorMessages?.startDate?.year}</p>
                            }
                        </div>
                    </div>
                    <Select
                        value={state.privacy || ""}
                        formContainer="w-full lg:w-64"
                        options={privacies.filter(p => ['public', 'private'].includes(p.name.toLowerCase()))}
                        height={40}
                        placeholder={t('pleaseSelect')}
                        name="job"
                        innerLabel={t('privacy')}
                        innerLabelClass="text-1xs 3md:text-xs font-semibold color-select-label leading-3.5 absolute left-4.5 top-3 3md:top-4"
                        onChange={(e) =>
                            setState((prev)=>({...prev, privacy:e}))
                        }
                        isMulti={false}
                        valueContainerClass = "-10px !important"
                    />
                    <CreatableSelect
                        isMulti
                        innerLabel={t('Category')}
                        options={categoryList}
                        placeholder={t('pleaseSelect')}
                        // value={state.category} 
                        defaultValue={milestone.categories.map((item => {return {label: item[currentLang()] || item.name, value:item.id}}))}
                        height={68}
                        onChange={(e) =>
                            handleInputChange({
                            target: { name: "category", value: e },
                            })
                        }
                        errorMessage={errorMessages?.category}
                        labelClass="text-sm font-bold text-darkerGray leading-4 marked"
                        />
                    
                </div>
                <div className="relative w-full bg-white rounded-md pl-2 pr-2 pt-1 border border-gray my-2 cursor-pointer" onClick={showPosition}>
                    <label className="block font-semibold text-gray-400 text-2xs 3md:text-xs pt-1">Job/Role Title</label>
                    <p className="text-[13px] sm:text-sm 3md:text-base 3md:leading-6 pt-1 pb-2">
                        <span>
                            {jobsList
                            .map((p) => {
                                const _pos = [p.job_role?.name?.trim() ?? p.job_role.label?.trim()];
                                if (p.description)
                                _pos.push(removePostalCode(p.description).trim());
                                return _pos.join(" - ");
                            })
                            .join("| ")
                            .trim()}
                        </span>
                    </p>
                </div>
                <div className="flex gap-4 milestone-location">
                    <Input
                        inputContainerClass="form-input-container mb-2"
                        value={state?.platform}
                        name="platform"
                        outsideLabel={t('platform')}
                        otherLabel={t('companyVenueNetwork')}
                        placeholder={t('centuryFox')}
                        optional={true}
                        outsideLabelClass="text-sm font-bold text-darkerGray"
                        noLabelPaddingY="1rem"
                        type="text"
                        onChange={handleInputChange}
                        errorMessage={errorMessages?.platform}
                    />
        
                    <div className="form-input-container mb-1">
                        <label for="location" className="text-sm font-bold text-darkerGray">
                            <div className="flex flex-row gap-x-2 items-center">
                                <div className="leading-4 mb-2">
                                    {t('location')}
                                    <span className="font-normal"> ({t('optional')})</span>
                                </div>
                            </div>
                            <span className="font-normal leading-4 text-sm text-darkerGray line-clamp-1">{t('cityTownState')}</span>
                        </label>
                        <div className="input-wrapper mt-2">
                            <AutoCompleteAddress
                            name="location"
                            value={state?.location || ""}
                            onChange={handleAddressChange}
                            placeholder="Hobart, Tas, AUS"
                            errorMessage={state.validationErrors?.location}
                            formContainer="mb-1"
                            />
                        </div>
                        </div>
                    </div>
                <div>
                {
                    descShow && 
                    <Suspense fallback={<Loading />}> 
                        <WYSIWYGEditor
                            label={t('description')}
                            optional={false}
                            defaultValue={state.desc === 'null' ? "" : state.desc}
                            limitChar={1500}
                            onChange={(value) =>
                                handleInputChange({
                                target: { name: "desc", value },
                                })
                            }
                            inputClass="border-none mb-0"
                            /> 
                    </Suspense> 
                }
                
                </div>
                    <div className="w-full md:grid md:grid-cols-[50px_repeat(3,1fr)_50px] gap-2 -mt-[20px]">
                        {/* Small button on left */}
                        <button
                            onClick={showMediaModal}
                            className={`rounded-md min-h-[2.875rem] bg-thBg flex items-center gap-2 justify-center w-full 2sm:w-auto mb-2 2sm:mb-1`}
                        >
                            <FaPlus className="text:base md:text-lg" />
                            <div className="inline md:hidden text:base">Add More Milestone</div>
                        </button>

                        {/* Inputs in columns 2, 3, 4 */}
                        {!_.isEmpty(linkTypeList) && linkTypeList
                        .slice(0, showAllMedia ? linkTypeList.length : !isMobile ? 3 : 2)
                        .map((btn, index) => (
                            <div
                            key={index}
                            style={{ gridColumn: (index % 3) + 2 }}
                            className="relative"
                            >
                            <InputType
                                inputContainerClass="flex-1 mb-2 2sm:mb-0"
                                value={btn?.label}
                                name="label"
                                placeholder="Button Label"
                                outsideLabelClass="text-sm font-bold text-darkerGray"
                                noLabelPaddingY="1rem"
                                inputIcon={iconData(btn)}
                                iconPosition="left"
                                type="text"
                                onChange={(value) => onLabel(value, index)}
                                errorMessagePosition="bottom"
                                maxLength={45}
                            />
                            </div>
                        ))}

                        {/* Small button on right */}
                        {!_.isEmpty(linkTypeList) && linkTypeList.length > (!isMobile ? 3 : 2) && (
                        <button
                            className={`rounded-md min-h-[2.875rem] h-full md:col-start-5 md:row-start-1 self-start w-full 2sm:w-auto ${
                                    showAllMedia ? "bg-lightBlack text-white" : "bg-thBg"
                                }`}

                            onClick={() => setShowAllMedia(!showAllMedia)}
                        >
                            {showAllMedia ? t("hide") : `+${linkTypeList.length - (!isMobile ? 3 : 2)}`}
                        </button>
                        )}
                    </div>

            </div>
        </div>
        </div>
    )
}

export default DetailedViewEdit;

const Loading = () => {
  return(
    <div class="mx-auto w-full max-w-3xl rounded-md p-4">
      <div class="flex animate-pulse space-x-4">
        <div class="size-10 rounded-full bg-gray-200"></div>
        <div class="flex-1 space-y-6 py-1">
          <div class="h-2 rounded bg-gray-200"></div>
          <div class="space-y-3">
            <div class="grid grid-cols-3 gap-4">
              <div class="col-span-2 h-2 rounded bg-gray-200"></div>
              <div class="col-span-1 h-2 rounded bg-gray-200"></div>
            </div>
            <div class="h-2 rounded bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  )
}